// Company, contact, and content data extracted from evLUXE source pages.

export const heroStats = [
  { value: 8, suffix: "", label: "Electric Scooters" },
  { value: 180, suffix: "kg", label: "Maximum Loading" },
  { value: 42, suffix: " AH", label: "Battery Options" },
  { value: 2, suffix: "", label: "Domestic + Export Focus", display: "Domestic + Export" },
];

export const whyChoose = [
  {
    title: "The Benchmark of Modern E-Mobility",
    short: "Modern E-Mobility",
    desc: "Our focus on cutting-edge innovation, refined design, and premium quality places evLUXE at the forefront of the electric vehicle transition.",
    icon: "Sparkles",
  },
  {
    title: "Next-Gen High-Capacity Batteries",
    short: "Next-Gen Batteries",
    desc: "Travel without limits with advanced battery options engineered for extended range, durability, and dependable everyday performance.",
    icon: "BatteryCharging",
  },
  {
    title: "Intelligent High-Torque Drives",
    short: "High-Torque Drives",
    desc: "Experience responsive acceleration and whisper-quiet power from waterproof BLDC hub motors built for smooth, effortless rides.",
    icon: "Gauge",
  },
  {
    title: "Sustainable Luxury & Zero Emissions",
    short: "Sustainable Luxury",
    desc: "Move toward a cleaner future without compromising on style or power, with eco-friendly mobility and zero tailpipe emissions.",
    icon: "Leaf",
  },
  {
    title: "Built for Indian Roads",
    short: "Built for Indian Roads",
    desc: "High load capacity, hydraulic suspension, and robust engineering tuned for Indian urban and semi-urban roads.",
    icon: "MapPinned",
  },
  {
    title: "Future-Ready Dealer Support",
    short: "Dealer Support",
    desc: "An expanding distributor-dealer network and authorised service infrastructure for a hassle-free ownership experience.",
    icon: "Handshake",
  },
];

export const technology = [
  { title: "BLDC Hub Motor", desc: "Waterproof brushless hub motors deliver smooth, quiet, high-torque power with minimal maintenance.", icon: "Cog" },
  { title: "High-Capacity Battery Options", desc: "Lead-acid and lithium-ion options from 26 AH to 42 AH to match range and budget needs.", icon: "BatteryCharging" },
  { title: "Digital LED Speed Meter", desc: "Crisp digital LED instrumentation for clear, at-a-glance ride information.", icon: "Gauge" },
  { title: "Hydraulic Suspension", desc: "Hydraulic suspension absorbs rough roads for a planted, comfortable ride.", icon: "Waypoints" },
  { title: "Disc Braking System", desc: "Front and rear disc options provide confident, progressive stopping power.", icon: "Disc3" },
  { title: "Tubeless Tyres", desc: "90-90-12 tubeless tyres on select models for safer, lower-maintenance riding.", icon: "CircleDot" },
  { title: "High Load Capacity", desc: "Engineered for up to 180 kg, ready for riders, pillions, and daily cargo.", icon: "Weight" },
  { title: "Zero Tailpipe Emissions", desc: "Clean electric drivetrains for sustainable, carbon-conscious urban mobility.", icon: "Leaf" },
];

export const timeline = [
  { year: "1960", text: "Company was founded in New Delhi." },
  { year: "1965", text: "Founded the Auto Parts Merchant Association (APMA)." },
  { year: "1975", text: "Became one of the biggest automotive parts companies in North India." },
  { year: "1985", text: "Became one of the biggest automotive parts distributors in India." },
  { year: "1995", text: "Started global business operations." },
  { year: "2003", text: "Became distributors of the FUYAO Group." },
  { year: "2011", text: "Became distributors for the SORL - RUILI Group." },
  { year: "2020", text: "Built one of the largest networks of authorised service centres in India." },
  { year: "2026", text: "Started electric vehicle manufacturing for domestic and export markets." },
];

export const aboutHighlights = [
  { value: "50,000+", label: "Annual Capacity", desc: "Ready to scale and meet global and domestic EV demand seamlessly." },
  { value: "Reliance MET", label: "State-of-the-Art Facility", desc: "Located in one of North India's biggest premium industrial zones in Haryana." },
  { value: "Global", label: "Domestic & Export", desc: "Proudly manufacturing in India, engineered to empower the world." },
];

export const dealerStats = [
  { value: 250, suffix: "+", label: "Selling points targeted by end of 2026" },
  { value: 500, suffix: "+", label: "Dealer network targeted by end of 2027" },
  { value: 4, suffix: "", label: "Tier-1 to Tier-4 city expansion", display: "Tier 1-4" },
];

export const contact = {
  phones: [
    { display: "7064649494", tel: "+917064649494" },
    { display: "9873335281", tel: "+919873335281" },
  ],
  email: "info@evluxe.in",
  website: "evluxe.in",
  websiteUrl: "https://evluxe.in/",
  corporateOffice: {
    label: "Corporate Office",
    address: "No.392 Ghitorni, Pillar No:114 M.G. Road, New Delhi 110030",
    maps: "https://maps.app.goo.gl/sB34hqTk4vDQYRKKA",
  },
  manufacturingUnit: {
    label: "Manufacturing Unit",
    address:
      "Plot No. 5, Sector 7B, North Avenue, Reliance Model Economic Township, Jhajjar, Haryana",
    maps: "https://maps.app.goo.gl/M5pye6nVtHGuu6fY6",
  },
};

export const faqs = [
  {
    q: "Are evLUXE scooters available for online purchase?",
    a: "Currently, this website is for product showcase and enquiry registration. Please register your interest and our team will contact you.",
  },
  {
    q: "How can I register interest?",
    a: "Use the Register Your Interest form on this page, or reach us directly via WhatsApp, phone, or email. Share your preferred model and city and our team will get in touch.",
  },
  {
    q: "Can I apply for a dealership?",
    a: "Yes. evLUXE is expanding its distributor-dealer network across India. Choose Dealer / Distributor in the enquiry form or use the Apply for Dealership button in the Dealer Network section.",
  },
  {
    q: "Does evLUXE handle B2B, fleet, and bulk electric scooter enquiries?",
    a: "Yes. evLUXE supports business buyers, fleet operators, bulk purchase enquiries, and institutional requirements through its sales team.",
  },
  {
    q: "Can distributors or export partners contact evLUXE?",
    a: "Yes. evLUXE welcomes distributor and export enquiries for electric scooters manufactured in India. Share your market, quantity, and contact details through the enquiry form.",
  },
  {
    q: "Which evLUXE model is best for me?",
    a: "It depends on your needs. Premium alloy-rim, tubeless, dual-disc models like the CR2 PRO range suit performance-focused riders, while CR1 and CR3 models offer dependable everyday value.",
  },
  {
    q: "Are lithium-ion battery options available?",
    a: "Yes. evLUXE models are offered with both lead-acid and lithium-ion battery options, ranging from 26 AH to 42 AH depending on the variant.",
  },
  {
    q: "What is the maximum loading capacity?",
    a: "evLUXE scooters are engineered for a maximum loading capacity of up to 180 kg.",
  },
  {
    q: "Where is evLUXE's manufacturing unit?",
    a: "The manufacturing unit is located at the Reliance Model Economic Township (MET) in Jhajjar, Haryana, one of North India's largest premium industrial zones.",
  },
  {
    q: "Can I make a fleet or bulk enquiry?",
    a: "Yes. Select Fleet / Business Buyer or Bulk / Fleet Enquiry in the form and our team will assist with fleet requirements.",
  },
];

export const buyerTypes = [
  "Individual Buyer",
  "Dealer / Distributor",
  "Fleet / Business Buyer",
  "Export Enquiry",
];

export const enquiryTypes = [
  "Product Enquiry",
  "Test Ride / Demo Interest",
  "Dealership Enquiry",
  "Bulk / Fleet Enquiry",
  "Service / Support",
  "General Question",
];
